import { FC } from 'react';
import { Button, Modal, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { trpc } from '../../services/trpc';
import { ModalContent } from './modal-content';

type Props = {};

export const Reminder: FC<Props> = ({}) => {
  const [opened, { open, close }] = useDisclosure(false);

  const { data: activeCount = 0 } = trpc.notifications.activeCount.useQuery();

  const getLabel = (count: number): string => {
    if (count > 99) return '99+';
    return count.toString();
  };

  const getColor = (count: number): string => {
    if (count === 0) return 'gray';
    if (count >= 15) return 'red';
    if (count >= 10) return 'orange';
    if (count >= 5) return 'yellow';
    return 'blue';
  };

  const color = getColor(activeCount);
  const label = getLabel(activeCount);

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="xl" fw="bold">
            Notifications
          </Text>
        }
        size="100%"
        styles={{ content: { maxWidth: '1400px' } }}
      >
        <ModalContent />
      </Modal>

      <Button
        variant="filled"
        size="compact-sm"
        radius="xl"
        color={color}
        onClick={open}
      >
        {label}
      </Button>
    </>
  );
};
